// active mega menu code
var findElement = $('#megamenu_2 ul.megamenu').eq(1).find('a');
findElement.each(function (index) {
  if (window.location.pathname == $(this).attr("href")) {

    $(this).addClass("intro");
    var el = $(this).closest('.megamenu .m_menu-item').eq(0);
    if (!$('.megamenu .m_menu-item.cl-active').length) {
      el.addClass("cl-active");
    }

  }
});

$(document).ready(function () {

  if (window.location.href.indexOf('constraint=') > 0) {
    $('.clear_all_filter').show();
  } else {
    $('.clear_all_filter').hide();
  }
  window.onpopstate = function (event) {
    if (window.location.href.indexOf('constraint=') > 0) {
      $('.clear_all_filter').show();
    } else {
      $('.clear_all_filter').hide();
    }
  }

  $('.variant_img_color_custom').bind('click', function () {
    //var newimg = $(this).attr('data-href');
    var productHandle = $(this).attr('data-handle');
    fetch(`https://${window.Shopify.shop}/products/` + productHandle + `.js`)
      .then(res => res.json())
      .then(products => {
        var featuredImage = products.featured_image;
        $(this).closest('.product-content-wrapper').find('.mpt-image').attr('srcset', featuredImage);

      });

  });

});
